import { c as _c } from "react/compiler-runtime";
interface ChatMessageProps {
  role: 'user' | 'assistant';
  content: string;
  isStreaming: boolean;
}
const ChatMessage = t0 => {
  const $ = _c(11);
  const {
    role,
    content,
    isStreaming
  } = t0;
  const isAssistant = role === "assistant";
  const t1 = `flex w-full ${isAssistant ? "justify-start" : "justify-end"}`;
  const t2 = isAssistant ? "glass rounded-2xl rounded-tl-sm px-4 py-3 text-sm font-sans text-foreground/80 max-w-[85%]" : "bg-primary/20 border border-primary/30 rounded-2xl rounded-tr-sm px-4 py-3 text-sm font-sans text-foreground ml-auto max-w-[85%]";
  let t3;
  if ($[0] !== content) {
    t3 = <p className="leading-relaxed whitespace-pre-wrap">{content}</p>;
    $[0] = content;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== isStreaming) {
    t4 = isStreaming && <span data-testid="streaming-cursor" className="inline-block size-2 rounded-full bg-primary/60 ml-1 animate-pulse" aria-hidden="true" />;
    $[2] = isStreaming;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = <div data-testid="chat-bubble" className={t2}>{t3}{t4}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t5) {
    t6 = <div className={t1}>{t5}</div>;
    $[8] = t1;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export { ChatMessage };